// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"381a6d76","796":"fe4b1efb"}[chunkId] + ".chunk.js";
};